import ToggleAdultContent from './ToggleAdultContent';
export default ToggleAdultContent;
